__turbopack_context__.v({
  "errorMessage": "formerrordisplay-module-scss-module__q3xFRq__errorMessage",
  "inlineErrorIcon": "formerrordisplay-module-scss-module__q3xFRq__inlineErrorIcon",
  "inlineErrorMessage": "formerrordisplay-module-scss-module__q3xFRq__inlineErrorMessage",
  "inlineErrorText": "formerrordisplay-module-scss-module__q3xFRq__inlineErrorText",
});
